module.exports = __webpack_public_path__ + "img/icon_package2.051f6362.png";